import { type PastMaintenancesMaps, type WebData, webDataError, webDataFetching, webDataNotAsked, webDataSuccess } from '@cobliteam/api-lib';
import { type Draft, produce } from 'immer';
import type { Reducer } from 'redux';
import type { PastMaintenancesAction } from './actions';
import { ActionTypes } from './actionTypes';

export interface PastMaintenancesState {
  pastMaintenancesMapsWebData: WebData<PastMaintenancesMaps>;
}

export const pastMaintenancesInitialState: PastMaintenancesState = {
  pastMaintenancesMapsWebData: webDataNotAsked(),
};

export const pastMaintenancesReducer: Reducer<PastMaintenancesState, PastMaintenancesAction> = produce((draft: Draft<PastMaintenancesState>, action: PastMaintenancesAction) => {
  switch (action.type) {
    case ActionTypes.LOAD_PAST_MAINTENANCES_REQUEST:
      draft.pastMaintenancesMapsWebData = webDataFetching();
      break;

    case ActionTypes.LOAD_PAST_MAINTENANCES_SUCCEEDED:
      draft.pastMaintenancesMapsWebData = webDataSuccess(action.payload);
      break;

    case ActionTypes.LOAD_PAST_MAINTENANCES_FAILED:
      draft.pastMaintenancesMapsWebData = webDataError();
      break;
  }
}, pastMaintenancesInitialState);
